import { graphql } from "@repo/graphql-types/gql";
import { useSearch } from "@tanstack/react-router";
import { AsyncDataWrapper } from "@/components/async-data-wrapper";
import { useGraphQL } from "@/hooks/use-graphql";
import { CommunityListMap } from "@/components/community-list-map";

interface CommunityFollowersProps {
  codUsuarios: number[];
  tabSelectedLabel: string;
}

const CommunityListFollowersQuery = graphql(/* GraphQL */ `
   query CommunityListFollowersQuery(
     $nomeMembro: String! = ""
     $codEspecialidades: [Int!] = []
     $codUnidades: [Int!] = []
     $codUsuarios: [Int!] = [0]
   ){
    perfisComunidade(
      first: 15
      stringBusca: $nomeMembro
      codUsuarios: $codUsuarios
      codUnidades: $codUnidades
      codEspecialidades: $codEspecialidades
    ){
      ...CommunityListMapFragment
    }
  }
`);

export const CommunityFollowers = ({
  codUsuarios,
  tabSelectedLabel,
}: CommunityFollowersProps): JSX.Element => {
  const search = useSearch({ from: "/settings/community/" });
  const memberName = search.memberName ?? "";

  const queryResult = useGraphQL(CommunityListFollowersQuery, {
    codUsuarios,
    codEspecialidades: search.specialties?.map(Number) ?? [],
    codUnidades: (search.locations as string[] | undefined)?.map(Number) ?? [],
    nomeMembro: memberName,
  });
  return (
    <AsyncDataWrapper {...queryResult}>
      {queryResult.data?.perfisComunidade ? (
        <CommunityListMap
          listData={queryResult.data.perfisComunidade}
          tabSelectedLabel={tabSelectedLabel}
        />
      ) : null}
    </AsyncDataWrapper>
  );
};
